import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { FormattedMessage } from 'react-intl';
import FormattedPrice from '../../global/FormattedPrice/FormattedPrice';

// helpers
import get from 'lodash.get';

const priceLabel = (
    <FormattedMessage id="PdpSharedDetailVersions.priceLabel" defaultMessage="Price" />
);

function PdpSharedDetailVersions({ item, currency }) {
    const versions = get(item, 'versions') || [];

    if (!versions.length) {
        return null;
    }

    return (
        <span data-tn="pdp-spec-more-editions-sizes">
            {versions.map((version, index) => {
                const convertedAmts = get(version, 'price.convertedAmountList');
                let price;
                const convertedAmt =
                    convertedAmts && convertedAmts.find(amt => amt.currency === currency);
                if (convertedAmt && convertedAmt.amount) {
                    price = (
                        <FormattedPrice
                            currency={currency}
                            value={Math.round(convertedAmt.amount)}
                        />
                    );
                }
                return (
                    <div key={index}>
                        <span>{get(version, 'description')}</span>{' '}
                        {!!price && (
                            <span>
                                {priceLabel}: {price}
                            </span>
                        )}
                    </div>
                );
            })}
        </span>
    );
}

PdpSharedDetailVersions.propTypes = {
    currency: PropTypes.string,
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailVersions, {
    item: graphql`
        fragment PdpSharedDetailVersions_item on Item {
            versions {
                description
                price {
                    convertedAmountList {
                        currency
                        amount
                    }
                }
            }
        }
    `,
});
